import styled from "styled-components";
import Box from "../../../layout/boxes/Box/Box";
import { BoxProps } from "../../../layout/boxes/Box/Box.types";
import { BOX_HEIGHT } from "../../TextInputContainer/TextInputContainer.styles";

export const StyledWithInputOptions = styled(Box)<BoxProps>`
	position: relative;

	.ContextBox {
		top: ${BOX_HEIGHT};
		left: 0;
	}
`;
